import { track } from '@tldraw/tldraw'
import { FontSlidersProps } from './Types'
import { useUpdateStyle } from 'components/VisualStudioPlayground/VisualEditor/hooks/useUpdateStyle'
import { observer } from 'mobx-react-lite'
import Styles from '../FontStylesPanel.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { Slider } from 'almanac-ui/Slider/Slider'
import {
  FontSizeStyle,
  LetterSpacingStyle,
  LineHeightStyle,
} from 'components/VisualStudioPlayground/VisualEditor/StyleProps'

const FontSliders = track(
  observer(({ editor, fontSizeStyle, lineHeightStyle, letterSpacingStyle }: FontSlidersProps) => {
    const updateStyle = useUpdateStyle(editor)

    return (
      <div className={Styles.adjustmentsContainer}>
        <div className={Styles.fontSection}>
          <div className={Styles.sliderHeader}>
            <Text variant="smallList">Font Size</Text>
            <Text color="var(--dark-100)" variant="label">
              {fontSizeStyle.type === 'shared' ? fontSizeStyle.value : 'Mixed'}
            </Text>
          </div>
          <div className={Styles.sliderContainer}>
            <Slider
              filled
              size="xlThumb"
              step={1}
              minValue={6}
              maxValue={144}
              value={fontSizeStyle.type === 'shared' ? fontSizeStyle.value : 16}
              onChange={(value) => updateStyle(FontSizeStyle, value)}
            />
          </div>
        </div>
        <div className={Styles.fontSection}>
          <div className={Styles.sliderHeader}>
            <Text variant="smallList">Line Height</Text>
            <Text color="var(--dark-100)" variant="label">
              {lineHeightStyle.type === 'shared' ? lineHeightStyle.value : 'Mixed'}
            </Text>
          </div>
          <div className={Styles.sliderContainer}>
            <Slider
              filled
              size="xlThumb"
              step={0.01}
              minValue={0.5}
              maxValue={2.5}
              pinnedValue={1.4}
              value={lineHeightStyle.type === 'shared' ? lineHeightStyle.value : 1.4}
              onChange={(value) => updateStyle(LineHeightStyle, value)}
            />
          </div>
        </div>
        <div className={Styles.fontSection}>
          <div className={Styles.sliderHeader}>
            <Text variant="smallList">Letter Spacing</Text>
            <Text color="var(--dark-100)" variant="label">
              {letterSpacingStyle.type === 'shared' ? letterSpacingStyle.value : 'Mixed'}
            </Text>
          </div>
          <div className={Styles.sliderContainer}>
            <Slider
              filled
              size="xlThumb"
              step={1}
              minValue={-200}
              maxValue={800}
              pinnedValue={0}
              value={letterSpacingStyle.type === 'shared' ? letterSpacingStyle.value : 0}
              onChange={(value) => updateStyle(LetterSpacingStyle, value)}
            />
          </div>
        </div>
      </div>
    )
  }),
)

export { FontSliders }
